var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-tel-input',{staticStyle:{"background-color":"#e8f0fe"},attrs:{"placeholder":_vm.schema.placeholder},on:{"onInput":_vm.onInput},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }